var isStorageSupported = typeof Storage !== "undefined";
export var storageKey = "chakra-ui-color-mode";
/**
 * Simple object to handle read-write to localStorage
 */

export var localStorageManager = {
  get: function get(init) {
    var exist = isStorageSupported && !!window.localStorage.getItem(storageKey);
    var value = exist ? window.localStorage.getItem(storageKey) : init;
    return value;
  },
  set: function set(value) {
    if (isStorageSupported) {
      window.localStorage.setItem(storageKey, value);
    }
  }
};
/**
 * Simple object to handle read-write to cookies
 */

export var cookieStorageManager = function cookieStorageManager(cookies) {
  return {
    get: function get(init) {
      var match = cookies.match(new RegExp("(^| )" + storageKey + "=([^;]+)"));
      var value = match ? match[2] : init;
      return value;
    },
    set: function set(value) {
      document.cookie = storageKey + "=" + value + "; max-age=31536000;";
    }
  };
};